<template>
    <router-link
        active-class="active | text-white"
        class="nio-button nio-button-blue | w-full flex items-center p-4 space-x-4 bg-white"
        :class="{
            'bg-gray-200 font-medium': hasUnreadMessages,
        }"
        :to="path"
        @click.native="onClick"
    >
        <avatar
            :background-class-name="hasUnreadMessages ? 'bg-gradient-blue' : 'bg-gray-400'"
            :src="fullName ? '' : '/img/default-person.png'"
            :username="fullName"
        >
            <nio-icon
                class="text-2xl"
                name="regular/archive"
                v-if="!conversation.active"
            />
        </avatar>

        <div class="flex-1 overflow-hidden">
            <div class="flex items-baseline">
                <div class="flex-1 truncate text-base | sm:text-lg">
                    <span v-if="fullName">{{ fullName }}</span>
                    <span v-else>{{ conversation.contact_phone.number | phone }}</span>
                </div>
                <div class="ml-2 text-sm" v-if="lastMessage">
                    {{ lastMessageDate }}
                </div>
            </div>
            <div class="mt-1" v-if="lastMessage">
                <p class="truncate" v-html="lastMessageBody" />
            </div>
        </div>
    </router-link>
</template>

<script>
    import { shortnameToOutput } from '@/utils/emoji.js';
    import Avatar from '@/components/Avatar.vue';

    export default {
        components: { Avatar },

        props: {
            conversation: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {
            fullName() {
                return this.formatFullName(this.conversation.contact_phone.contact);
            },

            lastMessage() {
                if (!this.conversation.messages.length) {
                    return null;
                }

                const message = this.conversation.messages[0];
                const body = message.attachments ? this.$t('chat.conversation.picture') : message.body;

                return {
                    ...message,
                    body,
                };
            },

            lastMessageBody() {
                if (!this.lastMessage) {
                    return '';
                }

                let body = '';

                if (this.lastMessage.direction == 'O') {
                    body += `${this.$t('chat.conversation.youAsSender')} : `;
                }

                if (this.lastMessage.body) {
                    body += shortnameToOutput(this.lastMessage.body);
                }

                return body;
            },

            lastMessageDate() {
                if (!this.lastMessage) {
                    return '';
                }

                const date = moment(this.lastMessage.created_at);
                const now = moment();

                // Today
                if (date >= now.startOf('day')) {
                    if (this.$i18n.locale == 'en') {
                        return date.format('h:mm A');
                    }

                    return date.format('H:mm');
                }

                // This Year
                if (date >= now.startOf('year')) {
                    return date.format('D MMM');
                }

                if (this.$i18n.locale == 'en') {
                    return date.format('M/D/YY');
                }

                return date.format('D/M/YY');
            },

            hasUnreadMessages() {
                const unreadMessages = this.conversation.messages.filter(message => !message.read);

                return !!unreadMessages.length;
            },

            path() {
                return {
                    name: 'chat',
                    params: {
                        id: this.conversation.id,
                    },
                };
            },
        },

        methods: {
            onClick() {
                this.$bus.emit('conversationList.close');
            },
        },
    };
</script>
